<template>
	<div>
		<div class="pei-item" :style="'background:'+colorRow.color" @click="onToWebView()">
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-if="row.type=='songpei'">
				送培
			</div>
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-else-if="row.type=='qcxj'">
				七彩星级
			</div>
			<div class="pei-item-top" :style="'color:'+colorRow.color" v-else>
				其他
			</div>
			<div class="pei-item-main">
				<div class="pei-item-city">{{row.city}}</div>
				<div class="pei-item-title show-two-row">{{row.name}}</div>
				<div class="pei-item-time" :style="'background:'+colorRow.color">
					{{getTime(row.startdate)}}~{{getTime(row.enddate)}}</div>

			</div>
			<div class="pei-item-btn">
				<!-- <div class="pei-btn-left" :style="'color:'+colorRow.color2">进入</div> -->
				<div class="pei-btn-right" :style="'color:'+colorRow.color" v-if="getStatus()">报名</div>
				<div class="pei-btn-right" :style="'color:'+colorRow.color" v-else>已结束</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		name: "PeiItem",
		components: {},
		props: {
			row: {
				type: Object,
				default: {}
			},
		},

		data: function() {
			return {
				duration: 300,
				colorRow: {}

			};
		},
		mounted() {
			this.getColor()
		},
		methods: {
			getStatus(){
				if(Date.parse(new Date())/1000 < this.row.etime){
					return true
				}else{
					return false
				}
			},
			onToWebView() {
				if (this.row.type == "songpei") {
					uni.navigateTo({
						url: '/pages/apps/songpei/SongpeiApplyFormBasic/SongpeiApplyFormBasic?url=https://h5.ccago.cn/cca-h5/dist/songpei-apply-form-basic?'+qs.stringify({saiqu_id: this.row.id})
					})
					// rbLink({
					// 	name: "SongpeiApplyFormBasic",
					// 	query: {
					// 		saiqu_id: row.id
					// 	}
					// });
				} else if (this.row.type == "cba") {
					uni.navigateTo({
						url: '/pages/apps/cba/CbaApplyFormBasic/CbaApplyFormBasic?url=https://h5.ccago.cn/cca-h5/dist/cba-apply-form-basic?'+qs.stringify({station_id: this.row.id})
					})
					// rbLink({
					// 	name: "CbaApplyFormBasic",
					// 	query: {
					// 		station_id: row.id
					// 	}
					// });
				} else {
					uni.navigateTo({
						url: '/pages/apps/huiyi/HuiyiApplyFormStep1/HuiyiApplyFormStep1?url=https://h5.ccago.cn/cca-h5/dist/huiyi-apply-form-step-1?'+qs.stringify({saiqu_id: this.row.id})
					})
					// rbLink({
					// 	name: "HuiyiApplyFormStep1",
					// 	query: {
					// 		saiqu_id: row.id
					// 	}
					// });
				}
			},
			onRbLink(item) {
				rbLink({
					name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
					query: item.url.query
				});
			},
			getTime(val) {
				return val.slice(5)
			},
			getColor() {
				let colors = [{
						color: '#FFC34A',
						color2: '#724E04',
						color3: '#A9740D'
					},
					{
						color: '#4EB5FF',
						color2: '#014E85',
						color3: '#1A9FFF'
					},
				]
				this.colorRow = colors[parseInt(Math.random() * 10) % 2]
			},
		},

		filters: {}
	};
</script>

<style scoped>
	.pei-item-time {
		height: 0.41rem;
		background: #FFC34A;
		line-height:0.41rem;
		padding: 0 0.24rem;
		background: #FFC34A;
		border-radius: 0.42rem;
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;

	}

	.pei-item-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pei-btn-left {
		width: 1.28rem;
		height: 0.43rem;
		border-radius: 0.22rem;
		line-height: 0.43rem;
		text-align: center;
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #724E04;
		background: #FFFFFF;
		opacity: 0.68;
		border: 0.02rem solid #FFFFFF;
		margin: 0 0.1rem;
	}

	.pei-btn-right {
		width: 1.28rem;
		height: 0.43rem;
		background: #FFFFFF;
		border-radius: 0.22rem;
		border: 1px solid #FFFFFF;
		line-height: 0.43rem;
		text-align: center;
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #A9740D;
		margin: 0 0.1rem;
	}

	.pei-item-title {
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333;
		margin-top: 0.2rem;
		margin-bottom: 0.3rem;
	}

	.pei-item-city {
		height: 0.67rem;
		font-size: 0.48rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333;
		line-height: 0.67rem;
		margin-top: -0.2rem;
	}

	.pei-item-main {
		flex: 1;
		background: #ffff;
		margin-top: 0.1rem;
		margin-bottom: 0.1rem;
		border-radius: 0.16rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0.1rem;
	}

	.pei-item-time-range {
		height: 0.3rem;
		font-size: 0.22rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.3rem;
	}

	.pei-item-bolid {
		width: 1rpx;
		height: 0.16rem;
		opacity: 0.8;
		background: #F2F7FF;
		margin-left: 0.1rem;
		margin-right: 0.1rem;
	}

	.pei-item-type {
		width: 1.12rem;
		height: 0.4rem;
		font-size: 0.28rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 0.4rem;
	}

	.pei-item {
		width: 3.36rem;
		height: 3.66rem;
		background: linear-gradient(226deg, #4BC1FF 0%, #5599FF 100%);
		border-radius: 0.16rem;
		margin-bottom: 0.2rem;
		padding: 0 0.1rem;
		display: flex;
		flex-direction: column;
		padding-bottom: 0.1rem;
	}

	.pei-item-top {
		display: flex;
		align-items: center;
		margin: 0 auto;
		height: 0.28rem;
		font-size: 0.2rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFC043;
		line-height: 0.28rem;
		padding: 0 0.3rem;
		background: #FFFFFF;
		border-radius: 0 0 0.16rem 0.16rem;
		margin-top: -0.02rem;
	}

	.show-two-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>



// WEBPACK FOOTER //
// PeiItem.vue?328c5f8e